import _ from "lodash";
import client from "lib/apolloClient/client";
import { postEvidenceFragment } from "./EvidenceFragments";
import {
  getUnitPlanEvidencesQuery,
  getUnitPlanFieldsQuery,
} from "./EvidenceQuery";

export const getUnitPlanFieldsFromCache = ({ id, uids }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUnitPlanFieldsQuery,
      variables: {
        id,
        uids,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getPostEvidenceDataFromCache = ({ postId }) => {
  let fragmentData = {};
  try {
    fragmentData = client.readFragment({
      id: `Post:${postId}`,
      fragmentName: "postItem",
      fragment: postEvidenceFragment.postEvidence,
    });
  } catch (e) {
    return {};
  }
  return fragmentData;
};

export const writePostEvidenceDataInCache = ({ postId, data }) => {
  try {
    client.writeFragment({
      id: `Post:${postId}`,
      fragmentName: "postItem",
      fragment: postEvidenceFragment.postEvidence,
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const getUnitPlanEvidencesFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUnitPlanEvidencesQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
